import chen2026semantic from '../assets/chen2026semantic.gif';
import chen2025upper from '../assets/chen2025upper.gif';
import chen23HIL from '../assets/chen23HIL.gif';
import chensafe23 from '../assets/chensafe23.gif';
import shu23two from '../assets/shu23two.avif';
import zhan23multi from '../assets/zhan23multi.avif';
import jia2022hierarchical from '../assets/jia2022hierarchical.avif';

export const FULL_NAME = "Yu Chen/陈煜/Stan Chen";
export const RESUME_LINK = "https://Andrewzh112.github.io/resume/resume.pdf";
export const FOOTER_TEXT = {
    text: "The web is heavily inspired by ",
    link: "https://andrewzh112.github.io/",
    linkText: "Andrew Zhao's website"
};
export const SOCIAL_LINKS = [
    {
        name: "Email",
        icon: "far fa-lg fa-envelope",
        link: "mailto:chen-y22@mails.tsinghua.edu.cn",
        text: "chen-y22@mails.tsinghua.edu.cn",
        showText: true
    },
    {
        name: "Google Scholar",
        icon: "fas fa-graduation-cap",
        link: "https://scholar.google.com/citations?user=8ySqPzwAAAAJ&hl=zh-CN",
        showText: false
    },
    {
        name: "Github",
        icon: "fab fa-lg fa-github",
        link: "https://github.com/STAN-32?tab=repositories",
        showText: false
    },
];

export const AWARDS = [
    {
        date: "Dec 2025",
        content: "Doctoral Student Program of the Young S&T Talents Cultivation Project, CAST (<span style=\"color: red; font-weight: bold;\">Top 1%</span> in Tsinghua University)",
    },
    {
        date: "Dec 2025",
        content: "Basic Research Program for Young Students (PhD Candidate) of the National Natural Science Foundation of China (<span style=\"color: red; font-weight: bold;\">国自然</span>博士生专项)",
    },
    {
        date: "2024 - 2025",
        content: "Tsinghua University Comprehensive Excellence Scholarship (2 times)",
    },
    {
        date: "Jun 2023",
        content: "IEEE Virtual Manipulation Challenge. <span style=\"color: red; font-weight: bold;\">2nd</span> Prize Winner",
    },
    {
        date: "2018 - 2022",
        content: "Excellent Student Scholarship (5 times)",
    },
    {
        date: "Nov 2021",
        content: "Qimin Scholarship (<span style=\"color: red; font-weight: bold;\">Top 2%</span> in Harbin Institute of Technology)",
    },
    {
        date: "Dec 2020",
        content: "China National Scholarship (<span style=\"color: red; font-weight: bold;\">Top 2%</span> in Harbin Institute of Technology)",
    },
    {
        date: "Oct 2020",
        content: "National First Prize, 2020 ABU Robocon 'Robo Rugby' (National <span style=\"color: red; font-weight: bold;\">third</span> place)",
    },
    {
        date: "Jul 2020",
        content: "National First Prize, 2020 ABU Robocon 'Robotic Equestrian Simulation Contest'",
    },
];

export const RESEARCH_EXPERIENCE = [
    {
        date: "12/2025 - 06/2026",
        content: "<strong>Personal Robotics Lab (PRL), Imperial College London</strong><br>Advisor: Prof. Yiannis Demiris",
    },
    {
        date: "12/2024",
        content: "<strong>Biorobotics Lab, National University of Singapore</strong><br>Advisor: Prof. Haoyong Yu",
    },
    {
        date: "09/2022 - Present",
        content: "<strong>IRM Lab, Department of Automation, Tsinghua University</strong><br>Advisor: Prof. Xiang Li",
    },
];


export const NEWS = [
    {
        date: "Dec 2025",
        content: "Doctoral Student Program of the Young S&T Talents Cultivation Project, CAST (<span style=\"color: red; font-weight: bold;\">Top 1%</span> in Tsinghua University)",
    },
];

export const FEATUREDPUBLICATIONS = [
    {
        id: 1,
        name: "A Semantic-Aware Framework for Safe and Intent-Integrative Assistance in Upper-Limb Exoskeletons",
        journal: "IEEE Robotics and Automation Letters",
        date: "Mar 2026",
        authors: "Yu Chen, Shu Miao, Chunyu Wu, Jingsong Mu, Bo OuYang, Xiang Li",
        image: chen2026semantic,
        link: "https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=11456356",
    },
    {
        id: 2,
        name: "Upper-limb rehabilitation with a dual-mode individualized exoskeleton robot: A generative-model-based solution",
        journal: "The International Journal of Robotics Research",
        date: "Jan 2025",
        authors: "Yu Chen, Shu Miao, Jing Ye, Gong Chen, Jianghua Cheng, Ketao Du, Xiang Li",
        image: chen2025upper,
        link: "https://doi.org/10.1177/02783649251333479",
    },
    {
        id: 3,
        name: "Learning to Assist Different Wearers in Multitasks: Efficient and Individualized Human-in-the-Loop Adaptation Framework for Lower-Limb Exoskeleton",
        journal: "IEEE Transactions on Robotics",
        date: "Sep 2024",
        authors: "Yu Chen, Shu Miao, Gong Chen, Jing Ye, Chenglong Fu, Bin Liang, Shiji Song, Xiang Li",
        image: chen23HIL,
        link: "https://ieeexplore.ieee.org/abstract/document/10695031",
    },
];

export const PUBLICATIONS = [
    {
        id: 1,
        name: "A Semantic-Aware Framework for Safe and Intent-Integrative Assistance in Upper-Limb Exoskeletons",
        journal: "IEEE Robotics and Automation Letters",
        date: "Mar 2026",
        authors: "Yu Chen, Shu Miao, Chunyu Wu, Jingsong Mu, Bo OuYang, Xiang Li",
        image: chen2026semantic,
        link: "https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=11456356",
    },
    {
        id: 2,
        name: "Upper-limb rehabilitation with a dual-mode individualized exoskeleton robot: A generative-model-based solution",
        journal: "The International Journal of Robotics Research",
        date: "Jan 2025",
        authors: "Yu Chen, Shu Miao, Jing Ye, Gong Chen, Jianghua Cheng, Ketao Du, Xiang Li",
        image: chen2025upper,
        link: "https://doi.org/10.1177/02783649251333479",
    },
    {
        id: 3,
        name: "Learning to Assist Different Wearers in Multitasks: Efficient and Individualized Human-in-the-Loop Adaptation Framework for Lower-Limb Exoskeleton",
        journal: "IEEE Transactions on Robotics",
        date: "Sep 2024",
        authors: "Yu Chen, Shu Miao, Gong Chen, Jing Ye, Chenglong Fu, Bin Liang, Shiji Song, Xiang Li",
        image: chen23HIL,
        link: "https://ieeexplore.ieee.org/abstract/document/10695031",
    },
    {
        id: 4,
        name: "Safe and Individualized Motion Planning for Upper-limb Exoskeleton Robots Using Human Demonstration and Interactive Learning",
        journal: "2024 International Conference on Robotics and Automation (ICRA)",
        date: "May 2024",
        authors: "Yu Chen, Gong Chen, Jing Ye, Xiangjun Qiu, Xiang Li",
        image: chensafe23,
        link: "https://ieeexplore.ieee.org/abstract/document/10610552",
    },
    {
        id: 5,
        name: "Two-Stage Trajectory-Tracking Control of Cable-Driven Upper-Limb Exoskeleton Robots with Series Elastic Actuators: A Simple, Accurate, and Force-Sensorless Method",
        journal: "2023 IEEE/RSJ International Conference on Intelligent Robots and Systems (IROS)",
        date: "Oct 2023",
        authors: "Yana Shu, Yu Chen, Xuan Zhang, Shisheng Zhang, Gong Chen, Jing Ye, Xiang Li",
        image: shu23two,
        link: "https://doi.org/10.1109/IROS55552.2023.10342056",
    },
    {
        id: 6,
        name: "Multi-Modal Learning and Relaxation of Physical Conflict for an Exoskeleton Robot with Proprioceptive Perception",
        journal: "2023 IEEE International Conference on Robotics and Automation (ICRA)",
        date: "May 2023",
        authors: "Xuan Zhang, Yana Shu, Yu Chen, Gong Chen, Jing Ye, Xiu Li, Xiang Li",
        image: zhan23multi,
        link: "https://doi.org/10.1109/ICRA48891.2023.10161255",
    },
    {
        id: 7,
        name: "Hierarchical Learning and Control for In-Hand Micromanipulation Using Multiple Laser-Driven Micro-Tools",
        journal: "2022 IEEE/RSJ International Conference on Intelligent Robots and Systems (IROS)",
        date: "Oct 2022",
        authors: "Yongyi Jia*, Yu Chen* (Equal contribution), Hao Liu, Xiu Li, Xiang Li",
        image: jia2022hierarchical,
        link: "https://ieeexplore.ieee.org/document/9982148",
    },
];

export const SERVICES = [
    {
        title: "Academic Service",
        description: "Reviewer for IJRR, T-RO, T-ASE, RA-L, ...<br>Reviewer for ICRA, IROS, ...",
    },
];

export const ABOUT_TEXT = `
<p>I am a fourth-year Ph.D. candidate in the Department of Automation at Tsinghua University, supervised by Prof. <a href='https://thu-irml.com/' target='_blank' rel='noopener noreferrer'>Xiang Li</a>.
I earned my bachelor's degree in Automation from the School of Astronautics, Harbin Institute of Technology, where I was part of the HIT Robotics Team (HITCRT) and won the national third place in the Robocon 2020.
In December 2024, I was a visiting student in Prof. <a href='https://cde.nus.edu.sg/bme/staff/dr-yuhy/' target='_blank' rel='noopener noreferrer'>Haoyong Yu</a>'s research group at the National University of Singapore. 
From 12/2025 to 06/2026, I will be a visiting student in the Personal Robotics Lab (PRL) at Imperial College London, under the supervision of Prof. <a href='https://profiles.imperial.ac.uk/y.demiris' target='_blank' rel='noopener noreferrer'>Yiannis Demiris</a>.
<p>My research primarily focuses on the development of safe, efficient, and user-friendly human-robot collaborative systems. My interests include:</p>
<ul>
    <li><span style="color: #4CAF50; background-color: #E8F5E9; padding: 2px 4px; border-radius: 3px;">Lower-Limb Exoskeleton</span> Assist with different wearers and tasks</li>
    <li><span style="color: #4CAF50; background-color: #E8F5E9; padding: 2px 4px; border-radius: 3px;">Upper-Limb Exoskeleton</span> Personalized rehabilitation.</li>
</ul>
`
